import React from "react";
import Home from "../pages/home/Home";
import Profile from "../pages/Profile";
import Dashboard from "../pages/Dashboard";
import NotFound from "../pages/NotFound";
import StreamStats from "../pages/StreamStats";
import Admin from "../pages/admin/Admin";
import SoundPlayerPage from "../pages/SoundPlayerPage";
import OverlayPlayerPage from "../pages/OverlayPlayerPage";
import MentionsLegales from "../pages/MentionsLegales";
import SetPasswordPage from "../pages/SetPasswordPage";
import TrialConfirmPage from "../pages/TrialConfirmPage";
import MaintenancePage from "../pages/MaintenancePage";
import RequireUserAuth from "../components/auth/RequireUserAuth";
import MaintenanceGuard from "../components/auth/MaintenanceGuard";

/**
 * Configuration des routes de l'application
 * Toutes les routes sont protégées par MaintenanceGuard (sauf /maintenance et /admin qui sont exemptées)
 */
export const appRoutes = [
  {
    path: "/",
    element: <MaintenanceGuard />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "dashboard",
        element: (
          <RequireUserAuth>
            <Dashboard />
          </RequireUserAuth>
        ),
      },
      {
        path: "stats",
        element: <StreamStats />,
      },
      {
        path: "sound-player",
        element: <SoundPlayerPage />,
      },
      {
        path: "overlay-player",
        element: <OverlayPlayerPage />,
      },
      {
        path: "mentions-legales",
        element: <MentionsLegales />,
      },
      {
        path: "set-password",
        element: <SetPasswordPage />,
      },
      {
        path: "trial-confirm",
        element: <TrialConfirmPage />,
      },
      {
        path: "maintenance",
        element: <MaintenancePage />,
      },
      {
        path: "admin",
        element: <Admin />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];
